module.exports = __webpack_public_path__ + "img/09.04f1bbb1.png";